import * as React from 'react';
import {Breadcrumb, Card, Grid, Icon, Input} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, RouteComponentProps, withRouter} from 'react-router-dom';
import {
    ColumnSelectableComponentProps,
    ColumnSortableComponentProps,
    FilterObjectComponentProps,
    InfinityScrollComponentProps,
    ViewSettingsComponentProps,
    withColumnSelection,
    withColumnSort,
    withFilterObject,
    withInfinityScrollHandlers,
    withPrintAndExport,
    withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import {
    getAllAdvanceDataCustomer,
    getAllAdvanceDataSupplier
} from "../../services/AdvanceDataService";
import {GUARD_ISCUSTOMER, GUARD_ISSUPPLIER} from '../../routes';
import {formatCurrency} from '../../utils/numbers';
import {AccountSelectionButton} from './AccountSelectionButton';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const COLUMNS: ColumnDefinition[] = [
    {
        fieldName: 'data.Sorte2',
        labelTranslationKey: 'AdvanceData.Article',
        required: true,
        cellRender: (v,row) =>  <p>{row.data.Sorte2}/{row.data.SorteFarbe}</p>,
        printExportRender: (v,row) => `${row.data.Sorte2}/${row.data.SorteFarbe}`
    }, {
        fieldName: 'data.Beschreibung',
        labelTranslationKey: 'AdvanceData.Description',
        required: true
    },
    {
        fieldName: 'data.SCodeWert01Text',
        labelTranslationKey: 'AdvanceData.SCode',
        cellAlign: 'right',
        required: false,
        cellRender: (_, row) => (row.data.SCodeWert01Text || '') + ' ' + (row.data.SCode01Text || ''),
        printExportRender: (_, row) => (row.data.SCodeWert01Text || '') + ' ' + (row.data.SCode01Text || '')
    },
    {
        fieldName: 'data.AnzahlVS',
        labelTranslationKey: 'AdvanceData.Count',
        required: true,
        cellRender: (v,row) =>  <p>{row.data.AnzahlVS* (Number(row.data.StVE) || 1)}</p>,
        printExportRender: (v, row) => row.data.AnzahlVS * (+row.data.StVE || 1)
    },
    {
        fieldName: 'data.Preis',
        labelTranslationKey: 'AdvanceData.Price',
        required: false,
        cellAlign: 'right',
        cellRender: v => formatCurrency(v || 0),
        printExportRender: v => formatCurrency(v || 0)
    },
    {
        fieldName: 'data.UhrzeitVSZ',
        labelTranslationKey: 'AdvanceData.Time',
        required: false,
        cellAlign: 'right'
    },
    {
        fieldName: 'data.KundeKonto',
        labelTranslationKey: 'AdvanceData.Customer',
        required: false,
        cellAlign: 'right',
        noSort: true,
        cellRender: v => v || "0999999",
        printExportRender: v  => v|| "0999999"
    },
    {
        fieldName: 'data.AnliefererKonto',
        labelTranslationKey: 'AdvanceData.Deliverer',
        required: false,
        cellAlign: 'right',
        noSort: true,
        cellRender: v => v || "0999999",
        printExportRender: v  => v|| "0999999"
    },
    {
        fieldName: 'data.Wagen',
        labelTranslationKey: 'AdvanceData.Cart',
        required: false
    },
    {
        fieldName: 'data.Qualitaet',
        labelTranslationKey: 'AdvanceData.Quality',
        required: false
    },
    {
        fieldName: 'data.Bemerkung',
        labelTranslationKey: 'AdvanceData.Comment',
        required: false
    }

];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

const Inventory = (props: {accountType: 'customer' | 'supplier' } & RouteComponentProps<any> & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {

    if(props.loadingInitial) {
        return <LoadingContainer showLogo={false}/>;
    }
    return (
        <>
            <AnalyticsTracking page={"preliminary_data/" + props.accountType}/>
            <div className={"sticky-header"}>
                <div className={"ui container"}>

                    <h3><Breadcrumb icon="right angle" sections={[
                        {
                            key: '1',
                            as: NavLink,
                            to:  "/advanceData/",
                            content: `${t ("Route.AdvanceData")}`,
                        }
                    ]} /></h3>

                    <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
                    <Grid columns={4} className={"HeadingGrid"} stackable={true}
                          style={{marginBottom: '1em'}}>
                        <Grid.Column width={5}>
                            <AccountSelectionButton value={props.filterObject.account}
                                                    accountType={props.accountType}
                                                    onChange={(account: string) => props.handleFilterChange('account', account)}
                            />
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                                   value={props.filterObject.filter}
                                   onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <ColumnSelectionButton
                                fluid
                                availableColumns={COLUMNS}
                                selectedColumns={props.selectedColumns}
                                onSave={props.updateSelectedColumns}/>
                        </Grid.Column>
                        <Grid.Column width={1}>
                            <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                                <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                                </div>
                            </div>
                        </Grid.Column>
                    </Grid>
                </div>
            </div>

            <div className={"ui container responsivewrapper"}>
                <DataTable
                    columns={COLUMNS}
                    data={props.data}
                    page={props.page}
                    totalPages={props.totalPages}
                    sortDirection={props.sortDirection}
                    sortColumn={props.sortColumn}
                    selectedColumns={props.selectedColumns}
                    getScrollParent={getScrollParent}
                    loadMore={props.loadMore}
                    handleSortChange={props.handleSortChange}
                    loading={props.loading}
                    filter={props.filterObject}
                />
                <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
                    <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                    </div>
                </div>
                <div style={{height: '2em'}}/>
            </div>
        </>
    )
};

const dataServiceCustomer = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size = 50): Promise<any> {
        return  getAllAdvanceDataCustomer(sortColumn, sortOrder, page, size, filter.filter ? filter.filter : "", filter.account);
    }
};

const dataServiceSupplier = {
    loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size = 50): Promise<any> {
        return  getAllAdvanceDataSupplier(sortColumn, sortOrder, page, size, filter.filter ? filter.filter : "", filter.account);
    }
};

const  AdvanceDataWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(Inventory)))))));

export const AdvanceDataCustomer = () => (
    <AdvanceDataWrapped
        viewName="advanceData"
        dataService={dataServiceCustomer}
        accountType="customer"
        defaultSortDirection="ASC"
        defaultSortColumn="data.Sorte2"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.AdvanceData")}`]}
    />
);
export const AdvanceDataSupplier = () => (
    <AdvanceDataWrapped
        viewName="advanceData"
        dataService={dataServiceSupplier}
        accountType="supplier"
        defaultSortDirection="ASC"
        defaultSortColumn="data.Sorte2"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
        }}
        printColumns={COLUMNS}
        printPath={[`${t ("Route.AdvanceData")}`]}
    />
);

export const AdvanceDataNavPage = (props: RouteComponentProps<{}>) => {
    const {match} = props;
    return (
        <div className={"ui container"}>
            <AnalyticsTracking page="preliminary_data" />
            <h3>{t("Route.AdvanceData")}</h3>
            {GUARD_ISSUPPLIER() && (
                <Card as={NavLink} to={`${match.path}/supplier`}>
                    <Card.Content style={{textAlign: 'center'}}>
                        <Icon name={"truck"} style={{size: '2em'}}/><br />
                        {t("Route.SalesSupplier")}
                    </Card.Content>
                </Card>
            )}
            {GUARD_ISCUSTOMER() && (
                <Card as={NavLink} to={`${match.path}/customer`}>
                    <Card.Content style={{textAlign: 'center'}}>
                        <Icon name={"shopping cart"} style={{size: '2em'}}/><br />
                        {t("Route.SalesCustomer")}
                    </Card.Content>
                </Card>
            )}
        </div>
    );
};